import SharedFormInput from '../shared/FormInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface AutoFormInputProps {
  section: number;
  name: string;
  label?: string;
  type?: string;
  step?: string | number;
  helpText?: string;
  value?: any;
  onChange?: (event: any) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  subLabel?: string;
  infoText?: string;
  disabled?: boolean;
}

const AutoFormInput = (props: AutoFormInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedFormInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoFormInput;
